import { HTML_ATTRIBUTE_INLINE_STYLE, HTML_TAG_CONSENT_SCRIPT, HTML_ATTRIBUTE_TRANSFORM_WRAPPER } from ".";
import { putHtmlCodeToDom } from "..";
/**
 * Put an prepared inline style to the DOM.
 */

function putStyleInlineToDom(node) {
  // Get the inline style itself
  var inlineStyle = node.getAttribute(HTML_ATTRIBUTE_INLINE_STYLE);
  node.removeAttribute(HTML_ATTRIBUTE_INLINE_STYLE); // Transform the tag to the `style`
  // We need to make such a hacky way because regex does not work and `outerHTML` has also some issues...

  var inlineStyleHtml = node.outerHTML.substr(HTML_TAG_CONSENT_SCRIPT.length + 1);
  inlineStyleHtml = inlineStyleHtml.substr(0, inlineStyleHtml.length - HTML_TAG_CONSENT_SCRIPT.length - 3);
  inlineStyleHtml = "<style".concat(inlineStyleHtml).concat(inlineStyle, "</style>"); // Check, if there is a transform wrapper as we know from usual (non-inline) styles (e.g. transformToOriginalContentBlockerAttribute)

  var previousElementSibling = node.previousElementSibling;
  return putHtmlCodeToDom(inlineStyleHtml, {}, previousElementSibling !== null && previousElementSibling !== void 0 && previousElementSibling.hasAttribute(HTML_ATTRIBUTE_TRANSFORM_WRAPPER) ? previousElementSibling : node);
}

export { putStyleInlineToDom };